<template>
  <div class="form-group">
    <p class="help-block">
      {{ $t('Bareme.etape2.resultat.infoBaremeH', {anneePlus1: calculerAnneePlus1(), annee: dossier.periodeFiscale}) }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'section-info-bareme-h',
  props: ['dossier'],
  methods: {
    calculerAnneePlus1() {
      const annee = this.dossier.periodeFiscale;
      return Number(annee + 1);
    },
  },
};
</script>

<style scoped>

</style>
